import Lottie from "react-lottie";

interface LottieProps {
  animationData: any;
  height: any;
  width: any;
  loop?: any;
}

export default function LottieComp({ animationData, height, width, loop }: LottieProps) {
  const defaultOptions = {
    loop: loop,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions} height={height} width={width} />;
}
